import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../configureStore';
import { getInstitutions } from "../../redux/reducer/institution";
import InstitutionsTable from "../organisms/InstitutionsTable";
import { Card, Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import InstitutionsModal from "../molecules/InstitutionsModal";

const { Title } = Typography;

const AdminPanel = () => {
    const { accounts } = useMsal();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedInstitutionId, setSelectedInstitutionId] = useState<string>();
    const dispatch = useDispatch<AppDispatch>();

    const fetchInstitutions = useCallback(() => {
        if (accounts?.[0]?.idToken) {
            dispatch(getInstitutions({ 
                headers: { Authorization: `Bearer ${accounts[0].idToken}` } 
            }));
        }
    }, [accounts, dispatch]);

    useEffect(() => {
        fetchInstitutions();
    }, [fetchInstitutions]);

    const handleEdit = (institutionId?: string) => {
        setSelectedInstitutionId(institutionId);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedInstitutionId(undefined);
        setModalOpen(false);
    };

    const handleAddNew = () => {
        setSelectedInstitutionId(undefined);
        setModalOpen(true);
    };

    return (
        <Card
            style={{ margin: '24px' }}
            title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Title level={4} style={{ margin: 0 }}>Institutions</Title>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAddNew}
                    >
                        Add Institution
                    </Button>
                </div>
            }
        >
            <InstitutionsModal
                open={modalOpen}
                onClose={handleCloseModal}
                institutionId={selectedInstitutionId}
            />
            <InstitutionsTable onEdit={handleEdit} />
        </Card>
    );
};

export default AdminPanel;
